export default {
	"CouponItem.full": "滿",
	"CouponItem.available": "可用",
	"CouponItem.PickUpAgain": "再次領取",
	"CouponItem.ClaimItNow": "立即領取",
	"CouponItem.Details": "詳細資訊"
}